import { rgbToHex } from "@material-ui/core";
import { utils, writeFile, read, write } from "xlsx";
import { utils as utils_style, writeFile as writeFile_style, read as read_style, write as write_style } from "xlsx-js-style";

//Author: Kyle Smithnpm
//This is my wrapper function for creating workbooks easily that get immediately pushed to user for download.
//jsonData should be formatted as follows:
/*
EXAMPLE JSON OF A WORKBOOK
{
    workbook: 'nameOfFile.xlsx',
    sheets: 
    [
        {
            name: 'SheetName',
            data:[['A1','B1','C1'], ['A2','B2','C2'], ['A3', 'B3', 'C3']]     //Note the data is an array of arrays, where each new array is a new row,
        },                                                                    // so you would typically have headers in the first array
        {
            name: 'SecondSheet', 
            data:[['A1','B1','C1'], ['A2','B2','C2'], ['A3', 'B3', 'C3']]
        }
    ]
}
*/

export function createPartsWorkbookAndDownload(jsonData, fileType, outputFileName){
  if (fileType !== "pdf"){

    const wb = utils_style.book_new();
  
    let borderStyle = {
      top: { style : "thin", color: "ff000000" }, 
      left: { style : "thin", color: "ff000000" }, 
      right: { style : "thin", color: "ff000000" }, 
      bottom: { style : "thin", color: "ff000000" } 
    }
  
    let row1 = [
      {v: "Part #", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle
      }},
      {v: "CLEI", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle
      }},
      {v: "OEM", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle
      }},
      {v: "Platform", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle
      }},
    ]
  
    let sheetRows = [row1]
  
    jsonData.forEach(row => {
      let rowToEnter = [
        {v: row["sku"]?row["sku"]:"", t: "s", s: { font: {name: "Calibri", sz: 12},
        border: borderStyle}},
        {v: row["clei"]?row["clei"]:"", t: "s", s: { font: {name: "Calibri", sz: 12},
        border: borderStyle}},
        {v: row["oem"]?row["oem"]:"", t: "s", s: { font: {name: "Calibri", sz: 12},
        border: borderStyle}},
        {v: row["platform"]?row["platform"]:"", t: "s", s: { font: {name: "Calibri", sz: 12},
        border: borderStyle}},]
      sheetRows.push(rowToEnter)
    });
  
    const sheet = utils_style.aoa_to_sheet(sheetRows);
  
    utils_style.book_append_sheet(wb, sheet, "Sheet1");
  
    var today = new Date();
    var jsonData = {
      workbook:
        (outputFileName!==""?outputFileName:"CLEI / SKU Lookup Results") + " - " +
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear() +
        (fileType==="xlsx"?".xlsx":".csv"),
      sheets: [{ name: "Orders", data: [] }],
    };
  
    writeFile_style(wb, jsonData.workbook,{
      bookType: (fileType==="xlsx"?"xlsx":"csv"),
      type: 'file'
    });

  }
}

export function createATTRANWorkbookAndDownload(){
  const wb = utils_style.book_new();

  let borderStyle = {
    top: { style : "thin", color: "ff000000" }, 
    left: { style : "thin", color: "ff000000" }, 
    right: { style : "thin", color: "ff000000" }, 
    bottom: { style : "thin", color: "ff000000" } 
  }

  let row3 = [,
    {v: "Renaissance RMA Request Form", t: "s", s: { font: {name: "Calibri", sz: 20, bold: true}, alignment: {horizontal: "center"} }},
  ]

  let row4 = [
    {v: "RMA Number (provided by Renaissance)", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
    fill: { fgColor: { rgb:"ffd9e1f2" } }, 
    border: borderStyle 
  }},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, 
    fill: { fgColor: { rgb:"ffd9e1f2" } }, border: borderStyle }},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, 
    border: borderStyle }},
  ]

  let row5 = [
    {v: "Date:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right"}, 
    fill: { fgColor: { rgb:"ffffff00" } }, 
    border: borderStyle }},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12}, 
    fill: { fgColor: { rgb:"ffffff00" } }, 
    border: borderStyle }},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12}, 
    fill: { fgColor: { rgb:"ffffff00" } }, 
    border: borderStyle }},,
    {v: "Email RMA Request to:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { vertical: "left"}, fill: { fgColor: { rgb:"ffffff00" } }, 
    border: borderStyle }},
    {v: "order-entry@renrns.com", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { vertical: "left"}, fill: { fgColor: { rgb:"ffffff00" } }, 
    border: borderStyle }} 
  ]

  let row6 = [
    {v: "Requester contact info:", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {vertical: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {vertical: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },,,
    {v: "jdavis@renrns.com", l: { Target: "mailto:jdavis@renrns.com" }, t: "s", 
    s: { font: {sz: 10, color: {rgb: "ff0563c1"}, underline: true},
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle } }
  ] 
  let row7 = [
    {v: "Name:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "Jay Whiting", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}},, 
    {v: "Ship items for repair to:", t: "s", s: { font: {name: "Calibri", sz: 12},
    fill: { fgColor: { rgb:"ffd9e1f2" } },
    border: borderStyle}}, 
    {v: "Renaissance Network Reinvent", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ] 
  let row8 = [
    {v: "CSSL Name:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "Anoka CSSL", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}},, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "1200 Lakeside pkwy bldg. 3", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ]

  let row9 = [
    {v: "Email:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "j918w@att.com", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}},, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "Flower Mound, TX", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ]

  let row10 = [
    {v: "Phone:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "763.422.2099", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}}, ,
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "75028", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ]

  let row11 = [
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "USA", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ]

  let row12 = [
    {v: "Return shipping address for repaired or replaced parts:", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "", t: "s", s: {  
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "", t: "s", s: {  
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },,
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}
  ]  

  let row13 = [
    {v: "Attn to: ", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "Anoka CSSL", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}},,
    {v: "Instructions:", t: "s", s: { font: {name: "Calibri", sz: 12},
    fill: { fgColor: { rgb:"ffd9e1f2" } },
    border: borderStyle} },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    fill: { fgColor: { rgb:"ffd9e1f2" } },
    border: borderStyle} },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    fill: { fgColor: { rgb:"ffd9e1f2" } },
    border: borderStyle} },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    fill: { fgColor: { rgb:"ffd9e1f2" } },
    border: borderStyle} }
  ]  

  let row14 = [
    {v: "Street Address:  ", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "900 Lund Blvd Suite 100", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}},, 
    {v: "1.  Fill in all fields on the left side of this form from Date down to Invoice information.", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]  

  let row15 = [
    {v: "City, State & Zip:", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "Anoka, MN 55303", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"},
    border: borderStyle}}, ,
    {v: "2.  Enter as much or all information for each part being sent to Renaissance with only one part per line below.", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]

  let row16 = [
    {v: "Invoice per CSSL Purchase Order", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: { horizontal: "center"},
    fill: { fgColor: { rgb:"ffffff00" }  }, 
    border: borderStyle}},
    {v: "", t: "s", s: {  
      fill: { fgColor: { rgb:"ffffff00" } }, 
      border: borderStyle 
    } },
    {v: "", t: "s", s: {  
      fill: { fgColor: { rgb:"ffffff00" } }, 
      border: borderStyle 
    } },,
    {v: "3.  Email the completed RMA request form to the Order Entry address indicated above.", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]  

  let row17 = [
    {v: "Purchase Order #   ", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" }, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "27124177", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"}, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}}, ,
    {v: "4.  When Renaissance assigns an RMA number and a copy of this form will be sent back to the requestor with the RMA # filled in at the top.", t: "s",s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]  

  let row18 = [
    {v: "Purchase Order LINE # ", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" }, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"}, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}}, ,
    {v: "5.  Send the items for repair to the Flower Mound TX Shipping address indicated above.", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]  

  let row19 = [
    {v: "Email Invoice to:  ", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" }, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: {horizontal: "center"}, 
    fill: { fgColor: { rgb:"ffffff00" } },
    border: borderStyle}},
    {v: "jl459c@att.com", l: { Target: "mailto:jl459c@att.com" }, t: "s", 
    s: { font: {sz: 10, color: {rgb: "ff0563c1"}, underline: true},
    fill: { fgColor: { rgb:"ffffff00" } }, alignment: { horizontal: "center" },
    border: borderStyle } },,
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle} }, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}}, 
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
  ]

  let row21 = [
    {v: "Defective Parts", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true},
    border: borderStyle} },
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true},
    border: borderStyle} }
  ]

  let row24 = [
    {v: "Item #", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "AT&T Part Number", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Manufacturer Part Number", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Manufacturer", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Part Description", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Asset Tag", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Serial Number", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },
    {v: "Fault Description", t: "s", s: { font: {name: "Calibri", sz: 12, bold: true}, alignment: {horizontal: "center"}, 
      fill: { fgColor: { rgb:"ffd9e1f2" } }, 
      border: borderStyle 
    } },]

    let row25 = [
    {v: "1", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "CEQ.46712", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "474948A", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "Nokia", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "RRH", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "ATT22553070", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "EB191560344", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "RF module failure", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row26 = [
    {v: "2", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row27 = [
    {v: "3", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row28 = [
    {v: "4", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row29 = [
    {v: "5", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row30 = [
    {v: "6", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row31 = [
    {v: "7", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row32 = [
    {v: "8", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row33 = [
    {v: "9", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row34 = [
    {v: "10", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row35 = [
    {v: "11", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row36 = [
    {v: "12", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row37 = [
    {v: "13", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row38 = [
    {v: "14", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row39 = [
    {v: "15", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row40 = [
    {v: "16", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row41 = [
    {v: "17", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row42 = [
    {v: "18", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row43 = [
    {v: "19", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]

    let row44 = [
    {v: "20", t: "s", s: { font: {name: "Calibri", sz: 12}, alignment: { horizontal: "right" },
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},
    {v: "", t: "s", s: { font: {name: "Calibri", sz: 12},
    border: borderStyle}},]


  var wscols = [
    {wch: 12.67},
    {wch: 46.67},
    {wch: 39.33},
    {wch: 22.78},
    {wch: 37.67},
    {wch: 36.67},
    {wch: 35.11},
    {wch: 52.67} 
  ];

  const sheet = utils_style.aoa_to_sheet([,,row3,row4,,,row5,row6,row7,row8,row9,row10,row11,row12,row13,row14,row15,row16,row17,row18,row19,,row21,row24,
  row25,row26,row27,row28,row29,row30,row31,row32,row33,row34,row35,row36,row37,row38,row39,row40,row41,row42,row43,row44]);
  
  //sheet["!ref"] = "A4:E21"

  sheet["!cols"] = wscols;

  sheet["!merges"] = []
  sheet["!merges"].push({s: {r:3, c:0}, e: {r:3, c:1}}, {s: {r: 6, c: 0}, e: {r: 6, c: 1}}, {s: {r: 7, c: 0}, e: {r: 7, c: 2}}, 
    {s: {r:2, c:1}, e: {r:2, c:2}}, {s: {r: 8, c: 0}, e: {r: 8, c: 1}}, {s: {r: 9, c: 0}, e: {r: 9, c: 1}}, 
    {s: {r: 10, c: 0}, e: {r: 10, c: 1}}, {s: {r: 11, c: 0}, e: {r: 11, c: 1}}, {s: {r: 17, c: 0}, e: {r: 17, c: 2}}, 
    {s: {r: 18, c: 0}, e: {r: 18, c: 1}}, {s: {r: 19, c: 0}, e: {r: 19, c: 1}}, {s: {r: 20, c: 0}, e: {r: 20, c: 1}}, 
    {s: {r: 12, c: 0}, e: {r: 12, c: 1}}, {s: {r: 14, c: 0}, e: {r: 14, c: 1}}, {s: {r: 15, c: 0}, e: {r: 15, c: 1}}, 
    {s: {r: 16, c: 0}, e: {r: 16, c: 1}}, {s: {r: 13, c: 0}, e: {r: 13, c: 2}}, {s: {r: 14, c: 4}, e: {r: 14, c: 7}},
    {s: {r: 15, c: 4}, e: {r: 15, c: 7}},{s: {r: 16, c: 4}, e: {r: 16, c: 7}},{s: {r: 17, c: 4}, e: {r: 17, c: 7}},
    {s: {r: 18, c: 4}, e: {r: 18, c: 7}},{s: {r: 19, c: 4}, e: {r: 19, c: 7}},{s: {r: 20, c: 4}, e: {r: 20, c: 7}},
    {s: {r: 22, c: 0}, e: {r: 22, c: 1}})

  utils_style.book_append_sheet(wb, sheet, "Sheet1");

  var today = new Date();
  var jsonData = {
    workbook:
      "Sample Orders Upload Spreadsheet " +
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear() +
      ".xlsx",
    sheets: [{ name: "Orders", data: [] }],
  };

  writeFile_style(wb, jsonData.workbook);
}

export function createAndDownloadWorkbook(jsonData) {
  var wb = utils.book_new();
  jsonData.sheets.forEach((sheet) => {
    wb.SheetNames.push(sheet.name);
    var ws = utils.aoa_to_sheet(sheet.data);
    wb.Sheets[sheet.name] = ws;
  });
  writeFile(wb, jsonData.workbook);
}
export async function readFileReturnHTML(file, sheetName) {
  var retVal = "";
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject("<h2>Error reading file</h2>");
    };

    reader.onload = (e) => {
      var data = new Uint8Array(reader.result);
      var wb = read(data, { type: "array" });

      try {
        retVal = write(wb, {
          sheet: sheetName,
          type: "binary",
          bookType: "html",
        });
        resolve(retVal);
      } catch {
        reject("<h2>Error reading file</h2>");
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

export async function readFileReturnJSON(file, sheetName) {
  var retVal = "";
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject("<h2>Error reading file</h2>");
    };

    reader.onload = (e) => {
      var data = new Uint8Array(reader.result);
      var wb = read(data, { type: "array" });
      retVal = utils.sheet_to_json(wb.Sheets[sheetName]);
      resolve(retVal);
    };
    reader.readAsArrayBuffer(file);
  });
}

export async function readATTFileReturnJSON(file, sheetName) {
  var retVal = "";
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject("<h2>Error reading file</h2>");
    };

    reader.onload = (e) => {
      var data = new Uint8Array(reader.result);
      var wb = read_style(data, { type: "array", cellStyles: true });
      retVal = utils.sheet_to_json(wb.Sheets[sheetName]);
      resolve(retVal);
    };
    reader.readAsArrayBuffer(file);
  });
}
